var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Эм, бэлдмэлийн тайлан")])
}
var staticRenderFns = []

export { render, staticRenderFns }